import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  InputText,
  Select,
  Text
} from 'mailup-web-components'
import { fieldValueOkState } from 'Pages/Task/recoil/state/page'
import {
  dynamicFieldState,
  taskConditionsState
} from 'Pages/Task/recoil/state/task'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'
import { triggerFieldFilterOptions, triggerFieldTypeOptios } from './const'

const ApplyConditionsFieldComponent = () => {
  const [
    { ApplyConditionsField, TaskApplyConditionsField },
    setTaskConditionsState
  ] = useRecoilState(taskConditionsState)
  const intl = useIntl()
  const dynamicField = useRecoilValue(dynamicFieldState)
  const fieldValueOk = useRecoilValue(fieldValueOkState)
  const [triggerFieldFilterOptionsValue, setTriggerFieldFilterOptionsValue] =
    useState([])

  useEffect(() => {
    setTriggerFieldFilterOptions(TaskApplyConditionsField.FieldType)
  }, [])

  const onChangeApplyConditionsField = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      ApplyConditionsField: !prev.ApplyConditionsField,
      isDirty: true
    }))

    setTriggerFieldFilterOptions(TaskApplyConditionsField.FieldType)
  }

  const onChangeIdField = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      TaskApplyConditionsField: {
        ...prev.TaskApplyConditionsField,
        IdField: val
      },
      isDirty: true
    }))
  }

  const onChangeFieldType = (val) => {
    setTriggerFieldFilterOptions(val)
    setTaskConditionsState((prev) => ({
      ...prev,
      TaskApplyConditionsField: {
        ...prev.TaskApplyConditionsField,
        FieldType: val,
        IdFieldFilter: 0
      },
      isDirty: true
    }))
  }

  const onChangeIdFieldFilter = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      TaskApplyConditionsField: {
        ...prev.TaskApplyConditionsField,
        IdFieldFilter: val,
        FieldValue:
          val !== 29 && val !== 28
            ? prev.FieldValue === undefined
              ? ''
              : val
            : ''
      },
      isDirty: true
    }))
  }

  const onChangeFieldValue = (e) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      TaskApplyConditionsField: {
        ...prev.TaskApplyConditionsField,
        FieldValue: e.target.value
      },
      isDirty: true
    }))
  }

  function setTriggerFieldFilterOptions(val) {
    let options = []
    if (triggerFieldFilterOptions) {
      switch (val) {
        case 1:
        case 2:
          options = triggerFieldFilterOptions.filter(
            (f) => f.value >= 7 && f.value <= 12
          ) // triggerFieldFilterForNumeric
          break
        case 3:
          options = triggerFieldFilterOptions.filter(
            (f) =>
              (f.value >= 1 && f.value <= 12) ||
              f.value === 28 ||
              f.value === 29
          ) // triggerFieldFilterForText
          break
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
          options = triggerFieldFilterOptions.filter(
            (f) => f.value >= 18 && f.value <= 27
          ) // triggerFieldFilterForDate
          break
        case 12:
          options = triggerFieldFilterOptions.filter((f) => f.value === 30) // triggerFieldFilterForDateAndHours
          break
        default:
          // triggerFieldFilterForText
          options = triggerFieldFilterOptions.filter(
            (f) =>
              (f.value >= 1 && f.value <= 12) ||
              f.value === 28 ||
              f.value === 29
          )
          break
      }

      setTriggerFieldFilterOptionsValue(
        options.map((m) => ({
          value: m.value,
          label: intl.formatMessage({ id: m.label })
        }))
      )
    }
  }

  return (
    <>
      <Flex alignItems='flex-start'>
        <FlexItem margin='10px 0 0 0'>
          <Checkbox
            checked={ApplyConditionsField}
            onChange={onChangeApplyConditionsField}
            label={intl.formatMessage({
              id: 'Load.Task.ConditionsWhenLabelAnagraphicField'
            })}
            data-mu-test='checkBox-ApplyConditionsField'
          />
        </FlexItem>
        <FormElement
          feedback={
            ApplyConditionsField && !TaskApplyConditionsField.IdField
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' margin='0 8px' minWidth='140px'>
            <Select
              value={TaskApplyConditionsField.IdField}
              onChange={onChangeIdField}
              searchable
              placeholder={intl.formatMessage({
                id: 'Load.SearchRecipients.SelectColumnPlaceholder'
              })}
              disabled={!ApplyConditionsField}
              options={dynamicField}
              error={
                ApplyConditionsField && !TaskApplyConditionsField.IdField
                  ? 'danger'
                  : null
              }
            />
          </Flex>
        </FormElement>
        <FlexItem margin='10px 0 0 0'>
          <Text>
            {intl.formatMessage({ id: 'Load.Task.ConditionsWhenLabelType' })}
          </Text>
        </FlexItem>
        <FormElement
          feedback={
            ApplyConditionsField && !TaskApplyConditionsField.FieldType
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' margin='0 8px' minWidth='140px'>
            <Select
              value={TaskApplyConditionsField.FieldType}
              onChange={onChangeFieldType}
              placeholder={intl.formatMessage({
                id: 'Load.Common.SelectAvalue'
              })}
              disabled={!ApplyConditionsField}
              options={triggerFieldTypeOptios.map((m) => ({
                value: m.value,
                label: intl.formatMessage({ id: m.label })
              }))}
              error={
                ApplyConditionsField && !TaskApplyConditionsField.FieldType
                  ? 'danger'
                  : null
              }
            />
          </Flex>
        </FormElement>
        <FormElement
          feedback={
            ApplyConditionsField && !TaskApplyConditionsField.IdFieldFilter
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : null
          }
        >
          <Flex display='block' margin='0 8px' minWidth='140px'>
            <Select
              placeholder={intl.formatMessage({
                id: 'Load.Common.SelectAvalue'
              })}
              value={TaskApplyConditionsField.IdFieldFilter}
              onChange={onChangeIdFieldFilter}
              disabled={!ApplyConditionsField}
              options={triggerFieldFilterOptionsValue}
              error={
                ApplyConditionsField && !TaskApplyConditionsField.IdFieldFilter
                  ? 'danger'
                  : null
              }
            />
          </Flex>
        </FormElement>
        {TaskApplyConditionsField.IdFieldFilter !== 28 &&
          TaskApplyConditionsField.IdFieldFilter !== 29 &&
          TaskApplyConditionsField.IdFieldFilter !== 20 && (
            <FormElement
              feedback={
                ApplyConditionsField &&
                !TaskApplyConditionsField.FieldValue &&
                TaskApplyConditionsField.IdFieldFilter !== 20
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : ApplyConditionsField && !fieldValueOk
                    ? intl.formatMessage({
                        id: 'Load.Common.ValidationWrongFormat'
                      })
                    : null
              }
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.Filters.InsertValuePlaceholder'
                })}
                onChange={onChangeFieldValue}
                value={TaskApplyConditionsField.FieldValue}
                disabled={!ApplyConditionsField}
                variant={
                  ApplyConditionsField &&
                  (!TaskApplyConditionsField.FieldValue || !fieldValueOk) &&
                  TaskApplyConditionsField.IdFieldFilter !== 20
                    ? 'danger'
                    : null
                }
              />
            </FormElement>
          )}
      </Flex>
    </>
  )
}

export default ApplyConditionsFieldComponent
